import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangEsIconmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 9c0 1.1.198 2.155.56 3.13l8.44.783 8.44-.783A8.98 8.98 0 0 0 18 9a8.98 8.98 0 0 0-.56-3.13L9 5.087.56 5.87A8.98 8.98 0 0 0 0 9Z",
		fill: "#FFDA44"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.441 5.87a9.003 9.003 0 0 0-16.88 0h16.88ZM.56 12.13a9.003 9.003 0 0 0 16.881 0H.561Z",
		fill: "#D80027"
	})]
});
const ForwardRef = forwardRef(SvgLangEsIconmin);
export { ForwardRef as ReactComponent };
